import React from 'react';
import { func } from 'prop-types';
import { Clear } from '@material-ui/icons';
import * as styles from './styles/styles.module.scss';
import newMapIcon from '../../../../assets/images/icons/maps/new-map-icon.svg';
import ShareModalDrawer from '../../shared/ShareModalDrawer';
import directionsIcon from '../../../../assets/images/icons/maps/directions.svg';
import downloadIcon from '../../../../assets/images/icons/maps/download.svg';
import printIcon from '../../../../assets/images/icons/maps/print.svg';
import shareIcon from '../../../../assets/images/icons/maps/share.svg';
import LegacyModal from 'components/LegacyModal';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const CreatedMapModal = ({ closeModal, handleShareClick, handleDirectionsClick, handleDownloadRoute, handlePrintClick }) => {
  return (
    <LegacyModal handleBackgroundClick={closeModal}>
      <div className={styles.container}>
        <button type="button" className={styles.clearIcon} onClick={closeModal}>
          <Clear />
        </button>
        <div className={styles.iconAndTitle}>
          <img src={newMapIcon} alt={StringConstantsMixin.strings.ICON} />
          <div className={styles.title}>{StringConstantsMixin.strings.MAP_CREATOR.NEW_MAP_CREATED}</div>
        </div>
        <div>
          <ShareModalDrawer title={StringConstantsMixin.strings.SHARE_MAP} imgLink={shareIcon} onClick={handleShareClick} />
          <hr />
          <ShareModalDrawer title={StringConstantsMixin.strings.TRACK_DETAIL.DIRECTIONS} imgLink={directionsIcon} onClick={handleDirectionsClick} />
          <hr />
          <ShareModalDrawer title={StringConstantsMixin.strings.TRACK_DETAIL.DOWNLOAD_ROUTE} imgLink={downloadIcon} onClick={handleDownloadRoute} />
          <hr />
          <ShareModalDrawer title={StringConstantsMixin.strings.PRINT_MAP} imgLink={printIcon} onClick={handlePrintClick} />
        </div>
      </div>
    </LegacyModal>
  );
};

CreatedMapModal.propTypes = {
  closeModal: func.isRequired,
  handleShareClick: func,
  handleDirectionsClick: func,
  handleDownloadRoute: func,
  handlePrintClick: func
};

CreatedMapModal.defaultProps = {
  handleShareClick: () => {},
  handleDirectionsClick: () => {},
  handleDownloadRoute: () => {},
  handlePrintClick: () => {}
};

export default CreatedMapModal;
